import axios from 'axios';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

// Public resolved menu — the single source of truth consumed by customer + POS.
export const getResolvedMenu = (storeId, channel = 'online') =>
  axios.get(`${API}/catalog/${storeId}/menu`, { params: { channel } });

// Server-authoritative pricing pipeline quote (Catalog -> Pricing -> Delivery -> tax).
export const getQuote = (storeId, body) =>
  axios.post(`${API}/catalog/${storeId}/quote`, body);

// Delivery engine config (read is public; write requires delivery.config capability).
export const getDeliverySettings = (storeId) =>
  axios.get(`${API}/catalog/${storeId}/delivery-settings`);
export const putDeliverySettings = (storeId, body, token) =>
  axios.put(`${API}/catalog/${storeId}/delivery-settings`, body, { headers: { Authorization: `Bearer ${token}` } });

// Helper: flatten resolved menu categories into a single product list.
export const flattenProducts = (menu) =>
  (menu?.categories || []).flatMap((c) => (c.products || []).map((p) => ({ ...p, category_name: c.name })));

// Is this product customisable (needs a variant/modifier picker) or a one-tap add?
export const isCustomisable = (product) =>
  (product?.variants?.length || 0) > 1 || (product?.modifier_groups?.length || 0) > 0;

export const defaultVariant = (product) => {
  const vs = product?.variants || [];
  return vs.find((v) => v.is_default) || vs[0] || null;
};

// "from ₹X" when multiple variants, else exact effective price.
export const displayPrice = (product) => {
  const vs = product?.variants || [];
  if (vs.length > 1) {
    const min = Math.min(...vs.map((v) => v.price));
    return { amount: min, from: true };
  }
  return { amount: product?.effective_price ?? (vs[0]?.price ?? 0), from: false };
};
